import React, { useRef, useState } from "react";

import "./history_event.scss";
import { HistoryEventType } from "../../../../schemas/history_event";

import crossIcon from "../../../../assets/images/icons/cross.svg";
import plusIcon from "../../../../assets/images/icons/plus.svg";
import ReactSwipe from "react-swipe";

function HistoryEvent(props: {
	historyEvent: HistoryEventType;
	onOpen: () => void;
}) {
	const [historyEventOpen, changeHistoryEventOpen] = useState<boolean>(false);
	const [imagesSliderShow, changeImagesSliderShow] = useState<boolean>(false);
	const [imagesSliderModalOpen, changeImagesSliderModalOpen] =
		useState<boolean>(false);
	const [currentScrollImageIndex, changeCurrentScrollImageIndex] =
		useState<number>();
	const [startScrollImageIndex, changeStartScrollImageIndex] =
		useState<number>();
	let modalSwiperRef = useRef<ReactSwipe | null>(null);
	let swiperRef = useRef<ReactSwipe | null>(null);

	const toggleImagesSlider = () => {
		if (!imagesSliderShow) {
			changeImagesSliderModalOpen(!imagesSliderModalOpen);
			setTimeout(() => {
				changeImagesSliderShow(!imagesSliderShow);
			}, 250);
		} else {
			changeImagesSliderShow(!imagesSliderShow);
			setTimeout(
				() => changeImagesSliderModalOpen(!imagesSliderModalOpen),
				500
			);
		}
	};

	return (
		<div className={"history_event " + (historyEventOpen ? "open" : "")}>
			<div className="date">
				<div className="delimiter"></div>

				<div className="year">{props.historyEvent.year}</div>
				<div className="day">
					{props.historyEvent.date.day +
						" " +
						props.historyEvent.date.monthName}
				</div>
			</div>

			<div
				className="content"
				onClick={(e) => {
					e.stopPropagation();
					if (!historyEventOpen) props.onOpen();
					changeHistoryEventOpen(!historyEventOpen);
					setTimeout(() => {
						changeStartScrollImageIndex(0);
						changeCurrentScrollImageIndex(0);
					}, 50);
				}}
			>
				<div className="event_name">
					<span>{props.historyEvent.name}</span>
				</div>
				<div className="icon_position">
					<div className="icon_wrapper">
						<div className="icon">
							<img
								src={plusIcon}
								className={
									"plus " + (historyEventOpen ? "hide" : "")
								}
								alt=""
							></img>
							<img
								src={crossIcon}
								className={
									"cross " + (historyEventOpen ? "" : "hide")
								}
								alt=""
							></img>
						</div>
					</div>
				</div>
				{!historyEventOpen && (
					<img
						className="cover"
						src={
							props.historyEvent.pic_big ??
							props.historyEvent.images[0]
						}
						alt=""
					></img>
				)}
				{historyEventOpen && (
					<div
						className="carousel_wrapper"
						onClick={(e) => {
							e.stopPropagation();
							toggleImagesSlider();
						}}
						onTouchEnd={() => {
							if (swiperRef.current) {
								changeCurrentScrollImageIndex(
									swiperRef.current.getPos()
								);
								changeStartScrollImageIndex(
									swiperRef.current.getPos()
								);
							}
						}}
					>
						<ReactSwipe
							swipeOptions={{ continuous: false }}
							className="carousel"
							ref={swiperRef}
						>
							{props.historyEvent.images.map((image, index) => (
								<div className="image_wrapper" key={index}>
									<img src={image} alt="" className="cover" />
								</div>
							))}
						</ReactSwipe>
						{swiperRef.current &&
							swiperRef.current.getNumSlides() !== 1 && (
								<div className="pagination">
									<div className="pages_wrapper">
										<div
											className={
												"page f " +
												(currentScrollImageIndex === 0
													? "active"
													: "")
											}
										></div>
										<div
											className={
												"page m " +
												(currentScrollImageIndex !==
													0 &&
												currentScrollImageIndex !==
													swiperRef.current.getNumSlides() -
														1
													? "active"
													: "")
											}
										></div>
										<div
											className={
												"page l " +
												(currentScrollImageIndex ===
												swiperRef.current.getNumSlides() -
													1
													? "active"
													: "")
											}
										></div>
									</div>
								</div>
							)}
					</div>
				)}

				<div className="additional_photo">
					{(props.historyEvent.pic_mini ||
						props.historyEvent.images[1]) && (
						<img
							src={
								props.historyEvent.pic_mini ??
								props.historyEvent.images[1]
							}
							alt=""
						></img>
					)}
				</div>

				<div className="description_wrapper">
					<div className="photo_count">
						{props.historyEvent.images.length} фото
					</div>
					<div
						className="description"
						dangerouslySetInnerHTML={{
							__html: props.historyEvent.detail_text,
						}}
					></div>
				</div>
			</div>

			{imagesSliderModalOpen && (
				<div
					className="modal_wrapper"
					style={{
						opacity: +imagesSliderShow,
						transition: "all .5s",
					}}
					onClick={() => toggleImagesSlider()}
					onTouchEnd={() => {
						if (modalSwiperRef.current) {
							changeCurrentScrollImageIndex(
								modalSwiperRef.current.getPos()
							);
							if (swiperRef.current) {
								swiperRef.current.slide(
									modalSwiperRef.current.getPos(),
									0
								);
							}
						}
					}}
				>
					<ReactSwipe
						swipeOptions={{
							continuous: false,
							startSlide: startScrollImageIndex,
						}}
						className="carousel"
						ref={modalSwiperRef}
					>
						{props.historyEvent.images.map((image, index) => (
							<div className="image_wrapper" key={index}>
								<img src={image} alt=""></img>
							</div>
						))}
					</ReactSwipe>
					{modalSwiperRef.current &&
						modalSwiperRef.current.getNumSlides() !== 1 && (
							<div className="pagination">
								<div className="pages_wrapper">
									<div
										className={
											"page f " +
											(currentScrollImageIndex === 0
												? "active"
												: "")
										}
									></div>
									<div
										className={
											"page m " +
											(currentScrollImageIndex !== 0 &&
											currentScrollImageIndex !==
												modalSwiperRef.current.getNumSlides() -
													1
												? "active"
												: "")
										}
									></div>
									<div
										className={
											"page l " +
											(currentScrollImageIndex ===
											modalSwiperRef.current.getNumSlides() -
												1
												? "active"
												: "")
										}
									></div>
								</div>
							</div>
						)}
				</div>
			)}
		</div>
	);
}

export default HistoryEvent;
